import { inject, Injectable } from '@angular/core';
import { WINDOW_TOKEN } from '../window.token';
import { LinkRegistryService } from '../link-registry.service';
import { SecurityService } from '../security.service';

import { ModalNotificationRegistryService } from './modal-notification-registry.service';
import {
  ModalIdLite,
  ModalTriggerConfiguration,
  MODAL_NOTIFICATION_CONFIGURATION,
  TriggerConfiguration,
  TriggerLinkIdType,
  ModalIdWB
} from './modal-notification.domain';
import { ModalNotificationMultipleService } from './modal-notification-multiple.service';

@Injectable({
  providedIn: 'root'
})
export class ModalNotificationLauncherService {

  private static readonly USER_PERMISSION: string = '!NEW_USER';

  private readonly securityService = inject(SecurityService);
  private readonly linkRegistryService = inject(LinkRegistryService);
  private readonly window = inject(WINDOW_TOKEN);
  private readonly triggerConfiguration: TriggerConfiguration = inject<TriggerConfiguration>(MODAL_NOTIFICATION_CONFIGURATION);
  private readonly modalNotificationRegistryService = inject(ModalNotificationRegistryService);
  private readonly modalNotificationMultipleService = inject(ModalNotificationMultipleService);

  private readonly hasPermission: boolean = this.securityService.hasPermission(ModalNotificationLauncherService.USER_PERMISSION);

  getTrigger(triggerId: string): ModalTriggerConfiguration {
    return this.triggerConfiguration[triggerId];
  }

  getMatchedModalNotificationTrigger(): ModalTriggerConfiguration | undefined {
    if (!this.hasPermission) {
      return undefined;
    }

    if (this.modalNotificationMultipleService.hasMultipleWhatsNewModal()) {
      const hasBeenLaunchedAlready = this.modalNotificationMultipleService.getMultipleWhatsNewModal().some((trigger: ModalTriggerConfiguration): boolean =>
        this.modalNotificationRegistryService.hasBeenLaunchedAlready(trigger)
      );
      const whatsNewModalTrigger = this.modalNotificationMultipleService.getMultipleWhatsNewTrigger();
      if (!hasBeenLaunchedAlready) {
        return whatsNewModalTrigger;
      } else {
        return undefined;
      }
    } else {
      let matchedTrigger: ModalTriggerConfiguration | undefined = undefined;
      Object.keys(this.triggerConfiguration).forEach((key: string): void => {
        if (matchedTrigger === undefined) {
          const trigger: ModalTriggerConfiguration = this.triggerConfiguration[key];
          const triggerUrl = trigger.triggerLinkId === TriggerLinkIdType.ANY_URL ? undefined : this.linkRegistryService.getLink(trigger.triggerLinkId);

          if (!this.modalNotificationRegistryService.hasBeenLaunchedAlready(trigger) &&
              (trigger.triggerLinkId === TriggerLinkIdType.ANY_URL || this.isMatchedUrl(triggerUrl))) {
            matchedTrigger = trigger;
          }
        }
      });
      return matchedTrigger;
    }
  }

  registerTriggerLaunch(trigger: ModalTriggerConfiguration): void {
    if (trigger.id === ModalIdLite.WHATS_NEW || trigger.id === ModalIdWB.WHATS_NEW) {
      const firstWhatsNewModal: ModalTriggerConfiguration = this.modalNotificationMultipleService.getMultipleWhatsNewModal()?.[0];
      if (firstWhatsNewModal) {
        this.modalNotificationRegistryService.registerLaunch(firstWhatsNewModal);
      }
    } else{
      this.modalNotificationRegistryService.registerLaunch(trigger);
    }
  }

  private isMatchedUrl(targetUrl: string | undefined): boolean {
    if(targetUrl) {
      const browserUrl = this.window.location?.href ?? '';
      return browserUrl.includes(targetUrl);
    }
    return false;
  }
}
